// export default 'http://portal.semesteratsea.org/api';
// export default 'https://stagingportal.semesteratsea.org/api/';
export default '/api';




// WEBPACK FOOTER //
// ./src/apiPath.js